import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import EditFeatureCategory from "./EditFeatureCategory";
import AddFeatureCategory from "./AddFeatureCategory";

const featureListEndpoint = ApiEndpoints.featureCategory.featureList;
const featureDeleteEndpoint = ApiEndpoints.featureCategory.featureDelete;

const tableHeader = ["Date", "title", "brief", "Slug"];
const tbody = ["createdAt", "title", "brief", "category_slug"];

export default function FeatureCategory() {
  const [catId, setCatId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", featureListEndpoint);
      const result = response.feature_categories;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (feature_category_id) => {
    const payload = { feature_category_id };
    try {
      const response = await ApiRequest("POST", featureDeleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: 'Feature Listing ',
    user: 'Admin',
    innerpage: 'Feature Listing'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}> Add +</Link>
        <DataTable data={data} tableHeader={tableHeader} tbody={tbody} setModalShow={setModalEditShow} setId={setCatId}
        // onDelete={handleDelete}
        />
      </div>
      <AddFeatureCategory show={modalShow} onHide={() => setModalShow(false)} />
      <EditFeatureCategory show={modaleditShow} catId={catId} onHide={() => setModalEditShow(false)} />
    </>
  );
}






